import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GlobalContextProvider } from "./Contexts/GlobalContext";
import zipy from 'zipyai';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
zipy.init("784f2aee", {
  rootDomain: 'programmingpathshala.com'
});
ReactDOM.render(
    <React.StrictMode>
        <GlobalContextProvider>
            <HelmetProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </HelmetProvider>
        </GlobalContextProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
